// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__194Jv","placeholdersHeader":"styles_placeholdersHeader__VHhK1","editorStyle":"styles_editorStyle__1daM5","placeholdersBox":"styles_placeholdersBox__2W6VX"};